(function ($) {
  DJ.addBehavior('checkboxesDropdown', '.checkboxes-dropdown', {
    attach: function () {
      const dropdown = this;
      const checkboxesWrapper = dropdown.querySelector('.form-checkboxes');
      const btnSelectAll = dropdown.querySelector('.js-form-item-checkbox-select-all input');
      const checkboxes = dropdown.querySelectorAll('.js-form-type-checkbox:not(.js-form-item-checkbox-select-all) input');
      const btnToggle = dropdown.querySelector('.checkboxes-dropdown__btn-toggle');
      const $body = $(document.body);

      jcf.replace(checkboxesWrapper, 'Scrollable', {
        alwaysPreventMouseWheel: true
      });

      const onCheckAll = (e) => {
        let checkboxChecked = true;

        if (!e.target.checked) {
          checkboxChecked = false;
        }

        for (let i = 0; i < checkboxes.length; i += 1) {
          const checkbox = checkboxes[i];

          checkbox.checked = checkboxChecked;
        }

        jcf.refresh(checkboxes);
      };

      const onUncheckMain = () => {
        btnSelectAll.checked = false;
        const childrenArray = [];
        const childrenCheckbox = dropdown.querySelectorAll('.js-form-type-checkbox:not(.js-form-item-checkbox-select-all) input');

        for (let i = 0; i < childrenCheckbox.length; i += 1) {
          const checkbox = childrenCheckbox[i];

          if (checkbox.checked) {
            childrenArray.push(checkbox.value);
          }
        }

        if (childrenArray.length === childrenCheckbox.length) {
          btnSelectAll.checked = true;
        }

        jcf.refresh(btnSelectAll);
        jcf.refresh(childrenCheckbox);
      };

      if (btnSelectAll) {
        btnSelectAll.addEventListener('click', (e) => {
          onCheckAll(e);
        });
      }

      for (let i = 0; i < checkboxes.length; i += 1) {
        const item = checkboxes[i];

        item.addEventListener('click', (e) => {
          onUncheckMain(e);
        });
      }

      const toggleDropdownClass = () => {
        dropdown.classList.toggle('checkboxes-dropdown--opened');
      };

      const clearBinds = () => {
        $body.off('click.bodyCloseCheckboxesDropdown');
        $(document).off('keydown.escCloseCheckboxesDropdown');
      };

      const onBodyClick = () => {
        $body.on('click.bodyCloseCheckboxesDropdown', (e) => {
          if (!($(e.target).closest('.checkboxes-dropdown__container').length)) {
            toggleDropdownClass();
            clearBinds();
          }
        });
      };

      const onEscKeyPress = () => {
        $(document).on('keydown.escCloseCheckboxesDropdown', (e) => {
          if (e.code === 'Escape') {
            toggleDropdownClass();
            clearBinds();
          }
        });
      };

      if (btnToggle) {
        btnToggle.addEventListener('click', () => {
          toggleDropdownClass();

          if (dropdown.classList.contains('checkboxes-dropdown--opened')) {
            jcf.refresh(checkboxesWrapper);

            const bodyTimer = setTimeout(() => {
              onEscKeyPress();
              onBodyClick();
              clearTimeout(bodyTimer);
            }, 50);
          } else {
            clearBinds();
          }
        });
      }
    }
  });
})(jQuery);
